<template>
  <article class="article-profile">
    <div class="form-container">
      <h3>Nouvel espace</h3>
      <form @submit.prevent>
        <label for="name">Nom de l'espace</label>
        <input
          ref="name"
          v-model="name"
          type="text"
          placeholder="Espace..."
          id="name"
        />
        <label for="color">Couleur</label>
        <input
          class="color"
          v-model="color"
          type="color"
          value="#f6b73c"
          id="color"
        />

        <button @click="saveWorkspace()" class="button">Enregistrer</button>
      </form>
    </div>
  </article>
</template>

<script>
import * as fb from '../../firebase';

export default {
  props: {},
  data() {
    return {
      name: '',
      color: '#000000',
    };
  },
  created() {},
  mounted() {
    this.$refs.name.focus();
  },
  methods: {
    saveWorkspace() {
      // CREATE
      const userRef = fb.usersCollection.doc(this.currentUserId);
      fb.workspacesCollection
        .add({
          createdOn: new Date(),
          creatorId: fb.auth.currentUser.uid,
          default: false,
          name: this.name,
          color: this.color,
          admins: [userRef],
        })
        .then((workspace) => {
          // Une fois créé, on l'ajoute à la liste de cet user
          userRef.get().then((doc) => {
            const user = doc.data();
            // On récupère les workspaces, on push le nouveau, et on modifie
            const { workspaces } = user;
            workspaces.push(workspace);
            userRef.update({ workspaces });
          });
        });
      this.$emit('close');
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped src="./WorkspaceForm.scss"></style>
